import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { StripePromotionCodeDTO } from "@/models/subscriptions/StripePromotionCodeDTO";
import { SubscriptionPurchase } from "@/models/subscriptions/SubscriptionPurchase";

class SubscriptionPurchaseUtilService {
  path: string;

  constructor(path: string) {
    this.path = path;
  }

  create({
    subscriptionPurchase,
    companyExternalId,
  }: {
    subscriptionPurchase: SubscriptionPurchase;
    companyExternalId: string;
  }): Promise<ApiResponseV2<SubscriptionPurchase>> {
    return HttpClientV2.post(`${this.path}/create`, { subscriptionPurchase, companyExternalId });
  }

  /**
   * ids: list of companies ids (not tenants)
   */
  createBatch({
    subscriptionPurchase,
    ids,
  }: {
    subscriptionPurchase: SubscriptionPurchase;
    ids: number[];
  }): Promise<ApiResponseV2<SubscriptionPurchase[]>> {
    return HttpClientV2.post(
      `${this.path}/create/batch`,
      { subscriptionPurchase, ids },
      {
        axiosConfig: {
          timeout: 1000 * 30,
        },
      }
    );
  }

  getActiveByTenant(tenantExternalId: string): Promise<ApiResponseV2<SubscriptionPurchase>> {
    return HttpClientV2.get(`${this.path}/active/tenant?tenantExternalId=${tenantExternalId}`);
  }

  disableByCompanyExternalId(companyExternalId: string): Promise<ApiResponseV2<SubscriptionPurchase>> {
    return HttpClientV2.put(`${this.path}/disable?companyExternalId=${companyExternalId}`, {});
  }

  getPromotionCodes(): Promise<ApiResponseV2<StripePromotionCodeDTO[]>> {
    return HttpClientV2.get(`${this.path}/promotion-code`);
  }
}

export default new SubscriptionPurchaseUtilService("api/utils/subscription-purchase");
